/* DOLO'S NIGHT — MAZE SURVIVAL banner. Owner-supplied key art (PLAY NOW baked in);
   the whole strip is the link, same 26px rhythm and frame as the other game banners. */
import { Link } from "react-router-dom";

export function DolosNightBanner() {
  return (
    <section className="highway-banner dolos-night-banner rb-glitch" data-testid="dolos-night-banner">
      <Link
        to="/side-games#dolos-night"
        className="dolos-night-banner-link"
        data-testid="dolos-night-banner-link"
        aria-label="Play Dolo's Night — Maze Survival"
      >
        <img
          loading="lazy"
          className="highway-banner-art"
          src="/assets/dolos-night-banner.webp"
          alt="Dolo's Night — Maze Survival: the panda runner with the red blade holding back the horde in a haunted maze"
        />
      </Link>
      <img className="rb-glitch-copy rb-glitch-a" src="/assets/dolos-night-banner.webp" alt="" aria-hidden="true" />
      <img className="rb-glitch-copy rb-glitch-b" src="/assets/dolos-night-banner.webp" alt="" aria-hidden="true" />
    </section>
  );
}
